import HomeHero from "components/HomeHero";
// markup

const IndexPage = () => {
  return (
    <div className="bg-primary text-white font-main tracking-wider">
      <HomeHero />
    </div>
  );
};

export default IndexPage;
